<style lang="scss">
  @import "footer";
</style>

<script>
import { APP_EXTERNAL_LINKS } from '../../../utils/constant'

export default {

  data () {
    return {
      appExternalLinks: APP_EXTERNAL_LINKS
    }
  }
}
</script>

<template>
  <footer>
    <div class="container-fluid footer-wrapper p-lg-0">
      <div class="row mb-3 justify-content-center pt-4 m-0">
        <div class="d-inline">
          <img
            src="@/assets/images/src-networks/src_light.png"
            class="src mr-1"
          >
        </div>
        <div class="d-inline">
          <img
            src="@/assets/images/src-networks/mastercard.svg"
            class="mastercard mr-1"
          >
        </div>
        <div class="d-inline">
          <img
            src="@/assets/images/src-networks/visa_light.svg"
            class="visa mr-2"
          >
        </div>
        <div class="d-inline">
          <img
            src="@/assets/images/src-networks/amex.svg"
            class="amex mr-1"
          >
        </div>
        <div class="d-inline">
          <img
            src="@/assets/images/src-networks/discover.svg"
            class="discover mr-1"
          >
        </div>
      </div>
      <div class="row m-0">
        <div class="col-sm-12">
          <div class="col-lg-8 col-md-8 col-sm-12 mx-auto">
            <div class="border-white border-top my-4" />
            <div class="row text-center">
              <div class="col-md-3 col-lg-3 col-sm-12">
                <a
                  :href="appExternalLinks.DEVELOPER_PORTAL"
                  class="text-white"
                  target="_blank"
                >
                  {{ $t ('footer.knowMore') }}
                </a>
              </div>
              <div class="col-md-3 col-lg-3 col-sm-12">
                <a
                  :href="'mailto:' + appExternalLinks.SUPPORT_EMAIL"
                  class="text-white"
                >
                  {{ $t ('footer.contactUs') }}
                </a>
              </div>
              <div class="col-md-3 col-lg-3 col-sm-12">
                <a
                  :href="appExternalLinks.TWITTER_LINK"
                  class="text-white"
                  target="_blank"
                >
                  {{ $t ('footer.askMastercard') }}
                </a>
              </div>
              <div class="col-md-3 col-lg-3 col-sm-12">
                <a
                  :href="appExternalLinks.API_LINK"
                  class="text-white"
                  target="_blank"
                >
                  {{ $t ('footer.requestInfo') }}
                </a>
              </div>
            </div>
            <div class="border-white border-top my-4" />
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-muted mt-4 pb-4">
        <span> {{ $t ('label.copyright') }}</span>
        <span>{{ new Date().getFullYear() }}</span>
        <span>{{ $t ('label.copyrightText') }}</span>
      </div>
    </div>
  </footer>
</template>
